import React, { useState, useEffect } from "react";
import KakaoMap from "./KakaoMap";

import "../scss/contact.scss";

function Contact() {
  const [formCheck, setFormCheck] = useState(false);

  const checkChange = (e) => {
    if (e.target.checked === true) {
      setFormCheck(true);
    } else {
      setFormCheck(false);
    }
  }

  const submitCheck = () => {
    return formCheck === false ? alert("개인정보수집에 동의해주세요") : "";
  }
  
  return (
    <div className="contact">
      <h2>
        궁금한 점 잇으시다면 <br />
        문의 주시면 친절하게 답변해드립니다.
      </h2>

      <div className="wrap2">
        <form action="">
          <label>
            <span>성함</span>
            <input type="text" />
          </label>

          <label>
            <span>연락처</span>
            <input type="text" />
          </label>

          <label>
            <span>문의내용</span>
            <textarea ></textarea>
          </label>

          <div>
            <input type="checkbox" id="check" onChange={checkChange} />
            <span>개인정보수집에 동의합니다.</span>
          </div>

          <button
            type={formCheck === true ? "submit" : "button"}
            onClick={() => {submitCheck()}}
          >제출</button>
        </form>
      </div>

      {KakaoMap(35.831681, 128.6271151, "aboutMap")}
    </div>
  )
}

export default Contact;